import Axios, { AxiosInstance } from 'axios'
import { apiConstants, ApiConstantsInterface } from '../constants/api.constants'
import IkonVouchersResponse from '@/models/IkonVouchersResponse'

interface IkonFriendsAndFamilyServiceInterface {
  getVouchers(): Promise<IkonVouchersResponse | null>
}

class IkonFriendsAndFamilyService implements IkonFriendsAndFamilyServiceInterface {
  protected axios: AxiosInstance

  protected config: ApiConstantsInterface

  constructor(config: ApiConstantsInterface) {
    this.config = config
    this.axios = Axios.create({
      baseURL: config.baseUrl,
      withCredentials: true,
    })
  }

  async getVouchers(): Promise<IkonVouchersResponse | null> {
    const response = await this.axios.get(this.config.vouchers)
    return response.data
  }
}

const ikonFriendsAndFamilyService = new IkonFriendsAndFamilyService(apiConstants)
export { ikonFriendsAndFamilyService }
